import { FC } from 'react';
import { Image, Skeleton } from "antd";
import { LeftOutlined } from "@ant-design/icons";

import useInfoScreen from '../../useInfoScreen';
import { EditableContent } from "../EditableContent";
import { ScreenButtons } from "../ScreenButtons";
import { ScreenLayout } from "../ScreenLayout";
import { ScreenButton } from "../ScreenButton";
import list from '../../images/list.png';
import styles from './index.module.scss'

export const OrdersNoResultScreen: FC<{ screenId: number }> = ({ screenId }) => {
  const { data, onEdit, loading } = useInfoScreen(screenId);
  if (loading) {
    return <Skeleton active={true} />;
  }
  return(
    <ScreenLayout
      hiddenTabs
      header={(
        <>
          <div className={styles.title}>
            <LeftOutlined style={{ fontSize: 18, marginRight: 12 }} />
            Результаты
          </div>
        </>
      )}
    >
      <Image
        width={170}
        height={170}
        alt="no result"
        preview={false}
        src={list}
      />
      <div className={styles.body}>
        <EditableContent type="header" maxLength={90} onSave={onEdit}>
          {data?.header}
        </EditableContent>
        <EditableContent type="body" maxLength={130} onSave={onEdit}>
          {data?.body}
        </EditableContent>
      </div>
      <ScreenButtons>
        <ScreenButton>
          Добавить
        </ScreenButton>
      </ScreenButtons>
    </ScreenLayout>
  )
}